export interface PageSkeletonProps {
  /** Number of skeleton rows to show in the table area */
  rows?: number;
  /** Whether to show KPI cards skeleton at top */
  showKpis?: boolean;
}

function SkeletonLine({ className = '' }: { className?: string }) {
  return <div className={`animate-pulse rounded-md bg-muted ${className}`} />;
}

export function PageSkeleton({ rows = 5, showKpis = false }: PageSkeletonProps) {
  return (
    <div className="space-y-6 p-6">
      {/* Page header skeleton */}
      <div className="flex items-center justify-between">
        <SkeletonLine className="h-8 w-48" />
        <SkeletonLine className="h-9 w-24" />
      </div>

      {/* KPI cards skeleton */}
      {showKpis && (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {Array.from({ length: 4 }).map((_, i) => (
            <div key={i} className="rounded-lg border p-6">
              <SkeletonLine className="mb-2 h-4 w-24" />
              <SkeletonLine className="h-8 w-32" />
            </div>
          ))}
        </div>
      )}

      {/* Table skeleton */}
      <div className="rounded-md border">
        {/* Header */}
        <div className="flex gap-4 border-b p-4">
          {Array.from({ length: 5 }).map((_, i) => (
            <SkeletonLine key={i} className="h-4 flex-1" />
          ))}
        </div>
        {/* Rows */}
        {Array.from({ length: rows }).map((_, i) => (
          <div key={i} className="flex gap-4 border-b p-4 last:border-0">
            {Array.from({ length: 5 }).map((_, j) => (
              <SkeletonLine key={j} className="h-4 flex-1" />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
